var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.358,
    viewBox: "0 0 16 15.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_26887",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 26887",
    d: "M1671.633,11652.016a7.693,7.693,0,1,0,6.652,3.853l-7.2,7.2a.641.641,0,0,1-.906,0l-2.849-2.851a.64.64,0,1,1,.9-.9l2.4,2.4,6.912-6.913A7.659,7.659,0,0,0,1671.633,11652.016Zm5.913,2.78a7.746,7.746,0,0,1,.739,1.072l1.479-1.48a.64.64,0,0,0-.9-.905Z",
    transform: "translate(-1663.953 -11652.016)",
    fill: "#22a873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkSign);
export default __webpack_public_path__ + "static/media/ok-sign.5de340a54a29d4486730518b436f2ca7.svg";
export { ForwardRef as ReactComponent };